import React from 'react';
import Icon from '../../../components/AppIcon';

const RecentActivityFeed = ({ activities }) => {
  const getActivityIcon = (type) => {
    switch (type) {
      case 'published':
        return 'CheckCircle';
      case 'scheduled':
        return 'Clock';
      case 'failed':
        return 'XCircle';
      case 'updated':
        return 'Edit';
      default:
        return 'FileText';
    }
  };

  const getActivityColor = (type) => {
    switch (type) {
      case 'published':
        return 'text-success';
      case 'scheduled':
        return 'text-primary';
      case 'failed':
        return 'text-error';
      case 'updated':
        return 'text-warning';
      default:
        return 'text-muted-foreground';
    }
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6 h-full">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground">Recent Activity</h3>
        <Icon name="Activity" size={20} className="text-primary" />
      </div>
      <div className="space-y-4 max-h-96 overflow-y-auto">
        {activities?.map((activity) => (
          <div key={activity?.id} className="flex items-start gap-3 pb-4 border-b border-border last:border-0 last:pb-0">
            <div className={`p-2 rounded-lg bg-muted ${getActivityColor(activity?.type)}`}>
              <Icon name={getActivityIcon(activity?.type)} size={16} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-foreground mb-1 truncate">{activity?.title}</p>
              <p className="text-xs text-muted-foreground mb-1">{activity?.site}</p>
              <p className="text-xs text-muted-foreground">{activity?.timestamp}</p>
            </div>
            {activity?.badge && (
              <span className={`px-2 py-1 rounded text-xs font-medium ${
                activity?.badge === 'Auto' ? 'bg-primary/10 text-primary' : 'bg-muted text-muted-foreground'
              }`}>
                {activity?.badge}
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentActivityFeed;